// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"1e3fbee4","647":"d4ba0807"}[chunkId] + ".chunk.js";
};